import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { qaroniAnimations } from '@qaroni-shared/animations/qaroni-animations';
import {
  CounterWidgetColor,
  CounterWidgetProperties,
  WidgetsConfiguration,
} from '@qaroni-shared/types/counter-widget-properties';

@Component({
  selector: 'qaroni-counter-widget',
  templateUrl: './counter-widget.component.html',
  styleUrl: './counter-widget.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [qaroniAnimations.enterFadeIn()],
  standalone: false,
})
export class CounterWidgetComponent {
  readonly icon = input.required<string>();
  readonly count = input<number>(0);
  readonly label = input.required<string>();
  readonly linkText = input.required<string>();
  readonly color = input<CounterWidgetColor>('primary');
  readonly alert = input<boolean>(false);
  readonly action = output<void>();

  get classes(): CounterWidgetProperties {
    return WidgetsConfiguration[this.color()];
  }

  public onAction(): void {
    this.action.emit();
  }
}
